import {useCallback} from 'react';
import {useCommonParams} from '@/hooks';
import {IPromoInfo, IPromoListItem} from '@/types';
import {clickEventHandler} from '@/helpers';
import {Header, PromoListItem} from '@/components/organisms';
import {
  PromoWrapper,
  Wrapper,
} from '@/components/templates/collectPromoList/CollectPromoList.styled';
import {COMPONENT_TYPE} from '@/const';

const CollectPromoList = (props: IPromoInfo) => {
  const {supports = [], title, needDivider} = props;
  const commonParams = useCommonParams();

  const handleClick = useCallback(
    (item: IPromoListItem) => {
      clickEventHandler({
        ...item,
        ...commonParams,
        componentName: COMPONENT_TYPE.TOP_SUPPORT,
      }).catch((e) => {
        console.log(e)
      });
    },
    [commonParams],
  );

  const renderComponent = (item: IPromoListItem, index: number) => (
    !item.lcsBanner && <PromoListItem key={index} {...item} onClick={() => handleClick(item)}/>
  );

  return (
    <Wrapper>
      <Header title={title} needDivider={needDivider}/>
      <PromoWrapper>
        {supports.length > 0 &&
          supports.map((item: IPromoListItem, index: number) => renderComponent(item, index))}
      </PromoWrapper>
    </Wrapper>
  );
};
export default CollectPromoList;
